import './style.scss'

interface HeaderAppProfilePicsProps {
	instructorName: string,
	instructorId: string
}

function HeaderAppProfilePics({instructorName, instructorId}: HeaderAppProfilePicsProps) {

	return (
		<div className="header-instructor-profile-pics">
			{/* <div className='header-instructor-profile-pics-wrap'> */}
			<a
				className='header-instructor-profile-pics-button'
				href={`app-instructor?id=${instructorId}`}
			>
				<img
					src={'/imgs/icons/instructor/icon-instructor-header-back-button.svg'}
					className='header-instructor-profile-pics-button-img'
					alt='Back Button'
				/>
			</a>
			<div className='header-instructor-profile-pics-name'>{instructorName}</div>
			{/* <a
				className='header-instructor-profile-pics-button'
				href={`app-instructor?id=${instructorId}`}
			>
				<img
					src={'/imgs/icons/instructor/icon-instructor-header-bell-button.svg'}
					className='header-instructor-profile-pics-button-img'
					alt='Bell Button'
				/>
			</a> */}
		</div>
	)
}

export default HeaderAppProfilePics